<app-common-modal #orderEmailModal (onClickYesButton)="clickSendButton(); hide()" [closable]="!loading"
                  [size]="'modal-lg'" [withFooter]="false" name="T_BOM_MAIL_TITLE"
                  title="{{'T_BOM_MAIL_TITLE' | translate}}">
  <div modal-body>
    <div class="body-margin bom-mail-modal">
      <app-spinner *ngIf="loading" [sizeClass]="'medium'" [vCenter]="false" class="spinner"></app-spinner>
      <form *ngIf="!loading" [formGroup]="form">
        <div class="col-12 relative">
          <div>
            <section>
              <!--to-->
              <div class="row mb-2 align-items-center">
                <label class="col-3 col-form-label text-end field-mandatory" for="toMail"
                       translate>T_BOM_MAIL_TO</label>
                <div class="col-9">
                  <input (change)="parseToList()"
                         [(ngModel)]="toMail"
                         [ngClass]="{'red-border-class': form.get('toMail').hasError('required') || form.get('toMail').hasError('pattern')}"
                         class="email form-control"
                         formControlName="toMail" id="toMail"
                         type="text"/>
                  <span class="se-icons info" container="body" tooltip="{{'T_BOM_MAIL_EMAILS' | translate}}">information_circle</span>
                  <div *ngIf="form.get('toMail').hasError('required') || form.get('toMail').hasError('pattern')">
                    <span *ngIf="form.get('toMail').hasError('required')" class="input-error" translate>T_EMAIL_FIELD_REQUIRED</span>
                    <span *ngIf="!form.get('toMail').hasError('required') && form.get('toMail').hasError('pattern')"
                          class="input-error" translate>T_EMAIL_EMAIL_REQUIRED</span>
                  </div>
                </div>
              </div>

              <!--cc-->
              <div class="row mb-2 align-items-center">
                <label class="col-3 col-form-label text-end" for="ccMail" translate>T_BOM_MAIL_CC</label>
                <div class="col-9">
                  <input (change)="parseToList()"
                         [(ngModel)]="ccMail"
                         [ngClass]="{'red-border-class': form.get('ccMail').hasError('pattern')}"
                         class="email form-control"
                         formControlName="ccMail" id="ccMail"
                         type="text"/>
                  <span class="se-icons info" container="body" tooltip="{{'T_BOM_MAIL_EMAILS' | translate}}">information_circle</span>
                  <div *ngIf="form.get('ccMail').hasError('pattern')">
                    <span *ngIf="form.get('ccMail').hasError('pattern')" class="input-error" translate>T_EMAIL_EMAIL_REQUIRED</span>
                  </div>
                </div>
              </div>

              <!--mySEAccount-->
              <div *ngIf="mySEAccount" class="row mb-2 align-items-center">
                <label class="col-3 col-form-label text-end" for="mySEAccount" translate>T_BOM_MAIL_MYSE_ACCOUNT</label>
                <div class="col-9">
                  <input (ngModelChange)="parseToList()"
                         [(ngModel)]="mySEAccount"
                         class="email form-control"
                         disabled="true"
                         formControlName="mySEAccount"
                         id="mySEAccount" type="text"/>
                </div>
              </div>

              <!--Order reference-->
              <div class="row mb-2 align-items-center">
                <label class="col-3 col-form-label text-end field-mandatory" for="orderReference" translate>T_BOM_MAIL_ORDER_REFERENCE</label>
                <div class="col-9">
                  <input [(ngModel)]="orderReference"
                         [ngClass]="{'red-border-class': form.get('orderReference').hasError('required') || form.get('orderReference').hasError('notEmpty')}"
                         class="email form-control"
                         formControlName="orderReference"
                         id="orderReference"
                         type="text"/>
                  <span class="se-icons info" container="body"
                        tooltip="{{'T_BOM_MAIL_ORDER_REFERENCE_TOOLTIP' | translate}}">information_circle</span>
                  <div
                    *ngIf="form.get('orderReference').hasError('required') || form.get('orderReference').hasError('notEmpty')">
                    <span class="input-error" translate>T_EMAIL_ORDER_REFERENCE_REQUIRED</span>
                  </div>
                </div>
              </div>

              <!--Required delivery date-->
              <div class="row mb-2 align-items-center">
                <label class="col-3 col-form-label text-end field-mandatory" for="requiredDate" translate>T_BOM_MAIL_REQUIRED_DATE</label>
                <div class="col-9">
                  <input [(ngModel)]="requiredDate"
                         [ngClass]="{'red-border-class': form.get('requiredDate').hasError('required') || form.get('requiredDate').hasError('notEmpty')
                         || form.get('requiredDate').hasError('inTheFuture')}"
                         class="email form-control"
                         formControlName="requiredDate"
                         id="requiredDate"
                         min="{{minDeliveryDate | date:'yyyy-MM-dd'}}"
                         type="date"/>
                  <span class="se-icons info" container="body"
                        tooltip="{{'T_EMAIL_REQUIRED_DATE_TOOLTIP' | translate}}">information_circle</span>
                  <div
                    *ngIf="form.get('requiredDate').hasError('required') || form.get('requiredDate').hasError('notEmpty')">
                    <span class="input-error" translate>T_EMAIL_REQUIRED_DATE_REQUIRED</span>
                  </div>
                  <div *ngIf="!form.get('requiredDate').hasError('required') && !form.get('requiredDate').hasError('notEmpty') &&
                  form.get('requiredDate').hasError('inTheFuture')">
                    <span class="input-error" translate>T_EMAIL_REQUIRED_DATE_IN_FUTURE</span>
                  </div>
                </div>
              </div>

              <!--Delivery address-->
              <div class="row mb-2 align-items-start">
                <label class="col-3 col-form-label text-end field-mandatory pt-2" for="deliveryAddress" translate>T_BOM_MAIL_DELIVERY_ADDRESS</label>
                <div class="col-9 ">
                  <div class="d-flex">
                  <textarea [(ngModel)]="deliveryAddress"
                            [ngClass]="{'red-border-class': form.get('deliveryAddress').hasError('required') || form.get('deliveryAddress').hasError('notEmpty')}"
                            class="form-control address-field"
                            formControlName="deliveryAddress"
                            id="deliveryAddress"
                            type="text">
                  </textarea>
                    <div class="d-flex align-items-center">
                      <span class="se-icons info" container="body"
                            tooltip="{{'T_BOM_MAIL_DELIVERY_ADDRESS_TOOLTIP' | translate}}">information_circle</span>
                    </div>
                  </div>
                  <div
                    *ngIf="form.get('deliveryAddress').hasError('required') || form.get('deliveryAddress').hasError('notEmpty')">
                    <span class="input-error" translate>T_EMAIL_DELIVERY_ADDRESS_REQUIRED</span>
                  </div>
                </div>
              </div>

              <!--Contact name-->
              <div class="row mb-2 align-items-center">
                <label class="col-3 col-form-label text-end field-mandatory" for="contactName" translate>T_BOM_MAIL_ORDER_CONTACT_NAME</label>
                <div class="col-9">
                  <input [(ngModel)]="contactName"
                         [ngClass]="{'red-border-class': form.get('contactName').hasError('required') || form.get('contactName').hasError('notEmpty')}"
                         class="email form-control"
                         formControlName="contactName"
                         id="contactName"
                         type="text"/>
                  <span class="se-icons info" container="body"
                        tooltip="{{'T_BOM_MAIL_ORDER_CONTACT_NAME_TOOLTIP' | translate}}">information_circle</span>
                  <div
                    *ngIf="form.get('contactName').hasError('required') || form.get('contactName').hasError('notEmpty')">
                    <span class="input-error" translate>T_BOM_MAIL_ORDER_CONTACT_NAME_REQUIRED</span>
                  </div>
                </div>
              </div>

              <!--Contact phone-->
              <div class="row mb-2 align-items-center">
                <label class="col-3 col-form-label text-end field-mandatory" for="contactPhone" translate>T_BOM_MAIL_ORDER_CONTACT_PHONE</label>
                <div class="col-9">
                  <input [(ngModel)]="contactPhone"
                         [ngClass]="{'red-border-class': form.get('contactPhone').hasError('required') || form.get('contactPhone').hasError('notEmpty')}"
                         class="email form-control"
                         formControlName="contactPhone"
                         id="contactPhone"
                         type="text"/>
                  <span class="se-icons info" container="body"
                        tooltip="{{'T_BOM_MAIL_ORDER_CONTACT_PHONE_TOOLTIP' | translate}}">information_circle</span>
                  <div
                    *ngIf="form.get('contactPhone').hasError('required') || form.get('contactPhone').hasError('notEmpty')">
                    <span class="input-error" translate>T_BOM_MAIL_ORDER_CONTACT_PHONE_REQUIRED</span>
                  </div>
                </div>
              </div>

              <!--Comments-->
              <div class="row mb-2 align-items-center">
                <label class="col-3 col-form-label text-end" for="comments" translate>T_BOM_MAIL_COMMENTS</label>
                <div class="col-9">
                  <input [(ngModel)]="comments"
                         [ngClass]="{'red-border-class': form.get('comments').hasError('required') || form.get('comments').hasError('notEmpty')}"
                         class="email form-control"
                         formControlName="comments"
                         id="comments"
                         type="text"/>
                </div>
              </div>

              <!--subject-->
              <div class="row mb-2 align-items-center">
                <label class="col-3 col-form-label text-end field-mandatory" for="subjectEmail" translate>T_BOM_MAIL_SUBJECT</label>
                <div class="col-9">
                  <input [(ngModel)]="subjectEmail"
                         [ngClass]="{'red-border-class': form.get('subjectEmail').hasError('required') || form.get('subjectEmail').hasError('notEmpty')}"
                         class="email form-control"
                         formControlName="subjectEmail"
                         id="subjectEmail"
                         type="text"/>
                  <span class="se-icons info" container="body" tooltip="{{'T_BOM_MAIL_SUBJECT_TOOLTIP' | translate}}">information_circle</span>
                  <div
                    *ngIf="form.get('subjectEmail').hasError('required') || form.get('subjectEmail').hasError('notEmpty')">
                    <span class="input-error" translate>T_EMAIL_SUBJECT_REQUIRED</span>
                  </div>
                </div>
              </div>

              <!--attachments-->
              <div class="row mb-2 align-items-center attachments">
                <label class="col-3 col-form-label text-end" translate>T_BOM_MAIL_ATTACHMENTS</label>
                <div class="col-9 files">
                  <em (click)="fileInput.click()" class="fa fa-paperclip pointer" style="font-size:20px;"></em>
                  <input #fileInput (change)="uploadFile($event)" style="display:none" type="file">
                  <a *ngFor="let attachmentEmail of attachmentsEmail"
                     class="attachment-file">{{ attachmentEmail.file.name }}
                    <em (click)="removeFile(attachmentEmail.file.name)" *ngIf="canRemoveFile(attachmentEmail)"
                        class="fa fa-remove pointer"></em>
                  </a>
                  <div>
                    <span *ngIf="!isSizeOk" class="input-error" translate>{{ attachmentsWrongSize }}</span>
                  </div>
                </div>
              </div>

              <!--body-->
              <div class="row mb-2 align-items-start">
                <label class="col-3 col-form-label text-end field-mandatory pt-2" for="bodyEmail" translate>T_BOM_MAIL_BODY</label>
                <div class="col-9">
                          <textarea [(ngModel)]="bodyEmail"
                                    [ngClass]="{'red-border-class': form.get('bodyEmail').hasError('required') || form.get('bodyEmail').hasError('notEmpty')}"
                                    class="message form-control"
                                    formControlName="bodyEmail"
                                    id="bodyEmail"
                                    type="text">
                  </textarea>
                  <div *ngIf="form.get('bodyEmail').hasError('required') || form.get('bodyEmail').hasError('notEmpty')">
                    <span class="input-error" translate>T_EMAIL_BODY_REQUIRED</span>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </form>
    </div>

    <!-- CUSTOM FOOTER -->
    <div *ngIf="!loading" class="modal-footer">
      <button (click)="clickSendButton()" [disabled]="!form.valid" class="btn btn-default-white-background" translate>
        T_BUTTON_SEND
      </button>
      <button (click)="clickCancelButton()" class="btn btn-default-white-background" translate>T_BUTTON_CANCEL</button>
    </div>
  </div>
</app-common-modal>
